// extracted by mini-css-extract-plugin
export default {"tableBody":"PhaseEditor-module__tableBody___pAlxS","phaseName":"PhaseEditor-module__phaseName___RRhYp","totalsWrapper":"PhaseEditor-module__totalsWrapper___hDFRr"};